export enum PresenterState {
  Intro,
  Wizard,
  ScheduleAppointment,
  AppointmentScheduled,
  SchedulingError,
}
